import { render, staticRenderFns } from "./TheCallCard.vue?vue&type=template&id=857f0142&scoped=true"
import script from "./TheCallCard.vue?vue&type=script&lang=js"
export * from "./TheCallCard.vue?vue&type=script&lang=js"
import style0 from "./TheCallCard.vue?vue&type=style&index=0&id=857f0142&prod&lang=css"
import style1 from "./TheCallCard.vue?vue&type=style&index=1&id=857f0142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857f0142",
  null
  
)

export default component.exports